"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3598 5.3825C17.5072 5.45149 17.6376 5.5521 17.7418 5.67719C17.8462 5.80201 17.9219 5.94831 17.9634 6.10568C18.0049 6.26305 18.0112 6.42763 17.9819 6.58773L16.7706 13.2538C16.7242 13.5099 16.5893 13.7415 16.3895 13.9083C16.1897 14.0751 15.9377 14.1663 15.6775 14.1662H6.66062C6.40051 14.1663 6.14862 14.0751 5.94888 13.9085C5.74914 13.7419 5.61421 13.5104 5.56763 13.2545L4.24016 5.97471C4.23309 5.94768 4.22806 5.92017 4.2251 5.89239L3.80921 3.61151H2.55551C2.40818 3.61151 2.26688 3.55299 2.16271 3.44881C2.05853 3.34463 2 3.20333 2 3.056C2 2.90867 2.05853 2.76737 2.16271 2.66319C2.26688 2.55902 2.40818 2.50049 2.55551 2.50049H3.80914C4.06926 2.50041 4.32116 2.59163 4.52091 2.75825C4.72067 2.92486 4.8556 3.1563 4.9022 3.41221L5.24248 5.27805H16.8888C17.0515 5.27785 17.2123 5.31352 17.3598 5.3825ZM11.6 8.74049C11.6 8.82885 11.6716 8.90049 11.76 8.90049H13.04C13.1284 8.90049 13.2 8.97212 13.2 9.06049V9.54049C13.2 9.62885 13.1284 9.70049 13.04 9.70049H11.76C11.6716 9.70049 11.6 9.77212 11.6 9.86049V11.1405C11.6 11.2289 11.5284 11.3005 11.44 11.3005H10.96C10.8716 11.3005 10.8 11.2289 10.8 11.1405V9.86049C10.8 9.77212 10.7284 9.70049 10.64 9.70049H9.36C9.27163 9.70049 9.2 9.62885 9.2 9.54049V9.06049C9.2 8.97212 9.27163 8.90049 9.36 8.90049H10.64C10.7284 8.90049 10.8 8.82885 10.8 8.74049V7.46049C10.8 7.37212 10.8716 7.30049 10.96 7.30049H11.44C11.5284 7.30049 11.6 7.37212 11.6 7.46049V8.74049Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.99961 17.4993C7.61321 17.4993 8.11063 17.0019 8.11063 16.3883C8.11063 15.7747 7.61321 15.2773 6.99961 15.2773C6.38601 15.2773 5.88858 15.7747 5.88858 16.3883C5.88858 17.0019 6.38601 17.4993 6.99961 17.4993Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.3323 17.4993C15.9459 17.4993 16.4433 17.0019 16.4433 16.3883C16.4433 15.7747 15.9459 15.2773 15.3323 15.2773C14.7187 15.2773 14.2213 15.7747 14.2213 16.3883C14.2213 17.0019 14.7187 17.4993 15.3323 17.4993Z",
    fill: fill
  }));
};

exports["default"] = _default;